import React from 'react';
import Link from '@atlaskit/link';
import * as Styled from '../styled';
import { FormattedMessage } from 'react-intl-next';
import messages from '../../project-pages-improvement/messages';

const TermsAndPrivacyPolicy = () => (
	<Styled.TermsAndPrivacyWrapper>
		<FormattedMessage
			defaultMessage={messages.termsAndConditionsV2.defaultMessage}
			id={messages.termsAndConditionsV2.id}
			values={{
				termsLink: (chunks: React.ReactNode[]) => (
					<Link target="_blank" href="https://www.atlassian.com/legal/cloud-terms-of-service">
						{chunks}
					</Link>
				),
				privacyLink: (chunks: React.ReactNode[]) => (
					<Link target="_blank" href="https://www.atlassian.com/legal/privacy-policy">
						{chunks}
					</Link>
				),
			}}
		/>
	</Styled.TermsAndPrivacyWrapper>
);
export default TermsAndPrivacyPolicy;
